module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_18.600d4520.png";